import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

import { firestore } from "firebaseConfig";
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useMaterialUIController } from "context";

function Categorias() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [tabIndex, setTabIndex] = useState(0);
  const [categoriasReceitas, setCategoriasReceitas] = useState([]);
  const [categoriasDespesasFixas, setCategoriasDespesasFixas] = useState([]);
  const [categoriasDespesasVariaveis, setCategoriasDespesasVariaveis] = useState([]);
  const [novaCategoria, setNovaCategoria] = useState("");
  const [novoEmoji, setNovoEmoji] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [userId, setUserId] = useState(null);

  const categoriasPadrao = {
    receitas: [
      { nome: "Salário", emoji: "💰", tipo: "receita" },
      { nome: "Freelance", emoji: "🧑‍💻", tipo: "receita" },
      { nome: "Rendimento de Investimentos", emoji: "📈", tipo: "receita" },
      { nome: "Bônus", emoji: "🎉", tipo: "receita" },
    ],
    despesasFixas: [
      { nome: "Aluguel", emoji: "🏠", tipo: "despesaFixa" },
      { nome: "Internet", emoji: "🌐", tipo: "despesaFixa" },
      { nome: "Energia Elétrica", emoji: "💡", tipo: "despesaFixa" },
      { nome: "Plano de Saúde", emoji: "🏥", tipo: "despesaFixa" },
    ],
    despesasVariaveis: [
      { nome: "Alimentação", emoji: "🍽️", tipo: "despesaVariavel" },
      { nome: "Transporte", emoji: "🚗", tipo: "despesaVariavel" },
      { nome: "Lazer", emoji: "🎬", tipo: "despesaVariavel" },
      { nome: "Restaurantes", emoji: "🍴", tipo: "despesaVariavel" },
    ],
  };

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);
      } else {
        setUserId(null);
      }
    });
  }, []);

  useEffect(() => {
    if (userId) {
      const categoriasCollectionRef = collection(firestore, "usuarios", userId, "categorias");

      const loadCategorias = async () => {
        try {
          const data = await getDocs(categoriasCollectionRef);

          if (data.empty) {
            await inserirCategoriasPadrao(categoriasCollectionRef);
          } else {
            const categorias = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
            setCategoriasReceitas(categorias.filter((cat) => cat.tipo === "receita"));
            setCategoriasDespesasFixas(categorias.filter((cat) => cat.tipo === "despesaFixa"));
            setCategoriasDespesasVariaveis(categorias.filter((cat) => cat.tipo === "despesaVariavel"));
          }
        } catch (error) {
          console.error("Erro ao carregar categorias:", error);
        }
      };

      const inserirCategoriasPadrao = async (ref) => {
        for (const categoria of [
          ...categoriasPadrao.receitas,
          ...categoriasPadrao.despesasFixas,
          ...categoriasPadrao.despesasVariaveis,
        ]) {
          await addDoc(ref, categoria);
        }

        loadCategorias();
      };

      loadCategorias();
    }
  }, [userId]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleAddCategoria = async () => {
    if (!novaCategoria.trim() || !userId) return;

    const novaCategoriaObj = {
      nome: novaCategoria,
      emoji: novoEmoji || "",
      tipo: tabIndex === 0 ? "receita" : tabIndex === 1 ? "despesaFixa" : "despesaVariavel",
    };

    const categoriasCollectionRef = collection(firestore, "usuarios", userId, "categorias");

    if (editIndex !== null) {
      const categoriaToEdit =
        tabIndex === 0
          ? categoriasReceitas[editIndex]
          : tabIndex === 1
          ? categoriasDespesasFixas[editIndex]
          : categoriasDespesasVariaveis[editIndex];

      await updateDoc(doc(categoriasCollectionRef, categoriaToEdit.id), novaCategoriaObj);

      if (tabIndex === 0) {
        const updatedCategorias = [...categoriasReceitas];
        updatedCategorias[editIndex] = { ...novaCategoriaObj, id: categoriaToEdit.id };
        setCategoriasReceitas(updatedCategorias);
      } else if (tabIndex === 1) {
        const updatedCategorias = [...categoriasDespesasFixas];
        updatedCategorias[editIndex] = { ...novaCategoriaObj, id: categoriaToEdit.id };
        setCategoriasDespesasFixas(updatedCategorias);
      } else if (tabIndex === 2) {
        const updatedCategorias = [...categoriasDespesasVariaveis];
        updatedCategorias[editIndex] = { ...novaCategoriaObj, id: categoriaToEdit.id };
        setCategoriasDespesasVariaveis(updatedCategorias);
      }
      setEditIndex(null);
    } else {
      const docRef = await addDoc(categoriasCollectionRef, novaCategoriaObj);
      novaCategoriaObj.id = docRef.id;

      if (tabIndex === 0) {
        setCategoriasReceitas([...categoriasReceitas, novaCategoriaObj]);
      } else if (tabIndex === 1) {
        setCategoriasDespesasFixas([...categoriasDespesasFixas, novaCategoriaObj]);
      } else if (tabIndex === 2) {
        setCategoriasDespesasVariaveis([...categoriasDespesasVariaveis, novaCategoriaObj]);
      }
    }

    setNovaCategoria("");
    setNovoEmoji("");
    setOpenPopup(false);
  };

  const handleDeleteCategoria = (index) => {
    setDeleteIndex(index);
    setConfirmDelete(true);
  };

  const confirmDeleteCategoria = async () => {
    if (deleteIndex !== null && userId) {
      const categoriasCollectionRef = collection(firestore, "usuarios", userId, "categorias");

      const categoriaToDelete =
        tabIndex === 0
          ? categoriasReceitas[deleteIndex]
          : tabIndex === 1
          ? categoriasDespesasFixas[deleteIndex]
          : categoriasDespesasVariaveis[deleteIndex];

      await deleteDoc(doc(categoriasCollectionRef, categoriaToDelete.id));

      if (tabIndex === 0) {
        setCategoriasReceitas(categoriasReceitas.filter((_, i) => i !== deleteIndex));
      } else if (tabIndex === 1) {
        setCategoriasDespesasFixas(categoriasDespesasFixas.filter((_, i) => i !== deleteIndex));
      } else if (tabIndex === 2) {
        setCategoriasDespesasVariaveis(categoriasDespesasVariaveis.filter((_, i) => i !== deleteIndex));
      }
      setDeleteIndex(null);
      setConfirmDelete(false);
    }
  };

  const handleEditCategoria = (index) => {
    setEditIndex(index);
    setOpenPopup(true);

    if (tabIndex === 0) {
      setNovoEmoji(categoriasReceitas[index].emoji);
      setNovaCategoria(categoriasReceitas[index].nome);
    } else if (tabIndex === 1) {
      setNovoEmoji(categoriasDespesasFixas[index].emoji);
      setNovaCategoria(categoriasDespesasFixas[index].nome);
    } else if (tabIndex === 2) {
      setNovoEmoji(categoriasDespesasVariaveis[index].emoji);
      setNovaCategoria(categoriasDespesasVariaveis[index].nome);
    }
  };

  const renderCategorias = () => {
    let categorias = [];
    if (tabIndex === 0) categorias = categoriasReceitas;
    else if (tabIndex === 1) categorias = categoriasDespesasFixas;
    else if (tabIndex === 2) categorias = categoriasDespesasVariaveis;

    return categorias.map((categoria, index) => (
      <Grid item xs={12} md={4} key={categoria.id}>
        <Card
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "nowrap",
            p: 1.5,
            mb: 2,
            borderRadius: "16px",
            boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.1)",
            border: darkMode ? "1px solid #444" : "1px solid rgba(0, 0, 0, 0.05)",
            backgroundColor: darkMode ? "#2A2A2A" : "#FFFFFF",
            minHeight: "48px",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)",
            },
          }}
        >
          <MDBox
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              flexWrap: "nowrap",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              flexGrow: 1,
            }}
          >
            <MDTypography
              sx={{
                fontSize: "1rem",
                mr: 1.5,
                display: "inline-flex",
                alignItems: "center",
                lineHeight: 1,
                color: darkMode ? "#FFFFFF" : "#344767",
              }}
            >
              {categoria.emoji}
            </MDTypography>
            <MDTypography
              variant="h6"
              sx={{
                fontSize: "1rem",
                fontWeight: "medium",
                display: "inline-flex",
                alignItems: "center",
                lineHeight: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                color: darkMode ? "#FFFFFF" : "#344767",
              }}
            >
              {categoria.nome}
            </MDTypography>
          </MDBox>

          <MDBox
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              flexWrap: "nowrap",
              flexShrink: 0,
            }}
          >
            <IconButton
              onClick={() => handleEditCategoria(index)}
              sx={{
                p: 0,
                mr: 0.5,
                color: darkMode ? "#FF9800" : "#F57C00",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: darkMode ? "#FFB300" : "#EF6C00",
                  transform: "scale(1.1)",
                },
              }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
            <IconButton
              onClick={() => handleDeleteCategoria(index)}
              sx={{
                p: 0,
                color: darkMode ? "#EF5350" : "#D32F2F",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: darkMode ? "#F44336" : "#B71C1C",
                  transform: "scale(1.1)",
                },
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </MDBox>
        </Card>
      </Grid>
    ));
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        py={3}
        sx={{
          backgroundColor: darkMode ? "#121212" : "transparent",
        }}
      >
        <MDBox mb={2} px={3}></MDBox>

        <MDBox px={3}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            centered
            variant="fullWidth"
            sx={{
              p: 0.5,
              mx: "auto",
              width: { xs: "100%", sm: "auto" },
              borderRadius: 9999,
              background: darkMode ? "rgba(17,25,40,0.55)" : "rgba(255,255,255,0.65)",
              border: darkMode ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(30,136,229,0.15)",
              boxShadow: darkMode ? "0 6px 18px rgba(0,0,0,0.35)" : "0 6px 18px rgba(30,136,229,0.08)",
              backdropFilter: "saturate(180%) blur(8px)",
              "& .MuiTabs-indicator": { display: "none" },

              "& .MuiTab-root": {
                minHeight: 40,
                borderRadius: 9999,
                textTransform: "none",
                fontWeight: 700,
                fontSize: { xs: "0.9rem", md: "1rem" },
                px: { xs: 1.5, md: 2.5 },
                transition: "all .2s ease",
                color: darkMode ? "rgba(255,255,255,0.72)" : "#5E7FA3",

                "&:hover": {
                  backgroundColor: darkMode ? "rgba(255,255,255,0.06)" : "rgba(221,241,255,0.7)",
                },

                "&.Mui-selected": {
                  color: darkMode ? "#A6D9FF" : "#1565D8",
                  background: darkMode
                    ? "linear-gradient(180deg, rgba(42,56,76,0.9) 0%, rgba(26,33,46,0.9) 100%)"
                    : "linear-gradient(180deg, #E6F5FF 0%, #F4FAFF 100%)",
                  border: darkMode ? "1px solid rgba(166,217,255,0.35)" : "1px solid #BFE7FF",
                  boxShadow: darkMode
                    ? "0 6px 14px rgba(0,0,0,0.40), inset 0 -2px 0 rgba(166,217,255,0.12)"
                    : "0 6px 14px rgba(21,101,216,0.12), inset 0 -2px 0 rgba(21,101,216,0.06)",
                },
              },
            }}
          >
            <Tab label="Receitas" />
            <Tab label="Despesas Fixas" />
            <Tab label="Despesas Variáveis" />
          </Tabs>
        </MDBox>

        <MDBox>
          <MDBox display="flex" justifyContent="center" mb={2}>
            <MDButton
              startIcon={<AddIcon fontSize="small" />}
              onClick={() => setOpenPopup(true)}
              sx={{
                height: 36,
                borderRadius: "10px",
                px: 2,
                backgroundColor: darkMode ? "#444" : "#fff",
                color: darkMode ? "#fff" : "#1976d2",
                border: darkMode ? "1px solid #666" : "1px solid #ddd",
                textTransform: "none",
                fontSize: "0.9rem",
                "&:hover": { backgroundColor: darkMode ? "#555" : "#f0f0f0" },
              }}
            >
              Adicionar Categoria
            </MDButton>
          </MDBox>

          <Grid container spacing={4}>
            {renderCategorias()}
          </Grid>
        </MDBox>

        {/* Popup para Adicionar/Editar Categoria */}
        <Dialog
          open={openPopup}
          onClose={() => {
            setOpenPopup(false);
            setEditIndex(null);
            setNovaCategoria("");
            setNovoEmoji("");
          }}
          PaperProps={{
            sx: (theme) => ({
              backgroundColor: darkMode ? "#1E1E1E" : theme.palette.background.default,
              color: darkMode ? "#FFFFFF" : theme.palette.text.primary,
              borderRadius: "12px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            }),
          }}
        >
          <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ color: darkMode ? "#FFFFFF" : "text.primary" }}>
              {editIndex !== null ? "Editar Categoria" : "Adicionar Nova Categoria"}
            </span>
            <IconButton
              onClick={() => {
                setOpenPopup(false);
                setEditIndex(null);
                setNovaCategoria("");
                setNovoEmoji("");
              }}
              sx={{
                color: darkMode ? "#B0BEC5" : "grey.600",
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <TextField
              label="Emoji (opcional)"
              value={novoEmoji}
              onChange={(e) => setNovoEmoji(e.target.value)}
              fullWidth
              margin="normal"
              placeholder="Exemplo: 🎉"
              InputLabelProps={{
                style: { color: darkMode ? "#B0BEC5" : "grey.600" },
              }}
              sx={{
                "& .MuiInputBase-input": {
                  color: darkMode ? "#FFFFFF" : "text.primary",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: darkMode ? "#444" : "grey.300",
                  },
                  "&:hover fieldset": {
                    borderColor: darkMode ? "#666" : "grey.500",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: darkMode ? "#42A5F5" : "primary.main",
                  },
                },
              }}
            />
            <TextField
              label="Nome da Categoria"
              value={novaCategoria}
              onChange={(e) => setNovaCategoria(e.target.value)}
              fullWidth
              margin="normal"
              InputLabelProps={{
                style: { color: darkMode ? "#B0BEC5" : "grey.600" },
              }}
              sx={{
                "& .MuiInputBase-input": {
                  color: darkMode ? "#FFFFFF" : "text.primary",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: darkMode ? "#444" : "grey.300",
                  },
                  "&:hover fieldset": {
                    borderColor: darkMode ? "#666" : "grey.500",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: darkMode ? "#42A5F5" : "primary.main",
                  },
                },
              }}
            />
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={handleAddCategoria}
              color="info"
              sx={{
                color: "#FFFFFF",
              }}
            >
              Salvar
            </MDButton>
          </DialogActions>
        </Dialog>

        {/* Popup de Confirmação de Exclusão */}
        <Dialog
          open={confirmDelete}
          onClose={() => setConfirmDelete(false)}
          PaperProps={{
            sx: (theme) => ({
              backgroundColor: darkMode ? "#1E1E1E" : theme.palette.background.default,
              color: darkMode ? "#FFFFFF" : theme.palette.text.primary,
              borderRadius: "12px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            }),
          }}
        >
          <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ color: darkMode ? "#FFFFFF" : "text.primary" }}>Confirmar Exclusão</span>
            <IconButton
              onClick={() => setConfirmDelete(false)}
              sx={{
                color: darkMode ? "#B0BEC5" : "grey.600",
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <MDTypography variant="body1" sx={{ color: darkMode ? "#FFFFFF" : "text.primary" }}>
              Tem certeza de que deseja excluir esta categoria?
            </MDTypography>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={confirmDeleteCategoria}
              color="error"
              sx={{
                color: "#FFFFFF", // Changed to white as requested
              }}
            >
              Excluir
            </MDButton>
          </DialogActions>
        </Dialog>
      </MDBox>
    </DashboardLayout>
  );
}

export default Categorias;
